<div class="comments-container">
  <div class="comments-header">
    <ion-icon name="chatbubbles-outline"></ion-icon>
    <span>Notizen</span>
  </div>

  <!-- Comments List -->
  <div class="comments-list" *ngIf="comments && comments.length > 0">
    <div 
      *ngFor="let comment of comments; trackBy: trackByIndex"
      class="comment-item"
      [class.own-comment]="isOwnComment(comment)"
      [class.change-reason]="comment.isChangeReason">
      
      <div class="comment-header">
        <span class="comment-user">{{ getUserName(comment.createdBy) }}</span>
        <span class="comment-date">{{ comment.createdAt | date:'dd.MM.yy HH:mm' }}</span>
      </div>
      
      <div class="comment-text">{{ comment.text }}</div>
      
      <div class="comment-badge" *ngIf="comment.isChangeReason">
        <ion-icon name="alert-circle-outline"></ion-icon>
        Änderungsbegründung
      </div>
    </div>
  </div>

  <div class="empty-state" *ngIf="!comments || comments.length === 0">
    Noch keine Notizen vorhanden
  </div>

  <!-- Hinweis: Kommentare erst nach Synchronisation möglich -->
  <div class="sync-hint" *ngIf="!orderSynced">
    <ion-icon name="cloud-offline-outline"></ion-icon>
    Notizen sind erst verfügbar, nachdem der Auftrag gespeichert/synchronisiert wurde
  </div>

  <!-- New Comment Input -->
  <div class="comment-input">
    <ion-textarea
      [(ngModel)]="newCommentText"
      placeholder="Notiz schreiben..."
      rows="2"
      [disabled]="sending || !orderSynced">
    </ion-textarea>
    <ion-button
      (click)="sendComment()"
      [disabled]="!newCommentText.trim() || sending || !orderSynced"
      size="small"
      fill="solid">
      <ion-icon name="send-outline" slot="start"></ion-icon>
      Senden
    </ion-button>
  </div>
</div>
